import React from 'react';
import SessionSidebar from '../components/SessionSidebar';

const SessionsPage: React.FC = () => {
  return (
    <div style={{ height: '100vh', display: 'flex' }}>
      <SessionSidebar />
      <div style={{ flex: 1, padding: '20px' }}>
        <h1>Sessions Management</h1>
        <p>Select a session from the sidebar or create a new one.</p>
      </div>
    </div>
  );
};

export default SessionsPage;
